import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { initLenis, scrollToTarget } from "@/lib/smooth";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { InkSplash } from "@/components/InkSplash";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const MobileContactBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 z-40 md:hidden pointer-events-none">
      <button
        type="button"
        onClick={() => scrollToTarget("#contact")}
        data-testid="mobile-sticky-contact-button"
        className="pointer-events-auto w-full text-center bg-ink text-paper py-4 text-sm font-medium tracking-wide shadow-[0_14px_34px_rgba(20,20,20,0.22)]"
      >
        Me contacter
      </button>
    </div>
  );
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="bg-paper text-ink">
      <BrowserRouter>
        <ErrorBoundary>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
            </Routes>
          </main>
          <Footer />
          <MobileContactBar />
        </ErrorBoundary>
      </BrowserRouter>
      <InkSplash />
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="bottom-center" theme="light" />
    </div>
  );
}

export default App;
